import FunctionHeader from "presentation/components/Header/FunctionHeader";
import ClientForm from "presentation/components/Client/ClientForm";
import Spinner from "presentation/components/Shared/Spinner";
import usePermissionCheck from "presentation/hooks/use-check-permissions";
import { useParams } from "react-router-dom";

const ClientFormPage = () => {
  const { id } = useParams();
  const { isLoading } = usePermissionCheck({ requiredFunction: "clients" });

  if (isLoading) {
    return <Spinner />;
  }

  const isEditing = !!id;

  const title = isEditing ? "Editar Cliente" : "Criar Cliente";
  return (
    <div>
      <FunctionHeader title={title} />
      <ClientForm />
    </div>
  );
};

export default ClientFormPage;
